<!--<div draggable="false" style="background-color:inherit;height:inherit;width:inherit;position:relative" (drop)="fakeNativeDrop()">-->
<!--<p>panel</p>-->
<ng-template #children></ng-template>
<!--</div>-->
